export default __webpack_public_path__ + "static/media/1951.c0f0bffb.png";